import { bodySmallStyles } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['05']};
  padding: 0;
`

export const Description = styled.div`
  ${bodySmallStyles};
  color: ${({ theme }) => theme.color.content.main};
  text-align: left;
`

export const Body = styled.div`
  padding-bottom: ${({ theme }) => theme.size.space['04']};
`

export const Footer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.size.space['05']};
  justify-content: flex-end;
  padding-top: ${({ theme }) => theme.size.space['05']};
`

export const ErrorMsg = styled.div`
  margin-bottom: ${({ theme }) => theme.size.space['05']};
  margin-top: ${({ theme }) => theme.size.space['05']};
`
